import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { Content } from "@learningblocks/shared-components/lib/Tooltip/Components/Content";
import { TooltipWrapper } from "@learningblocks/shared-components/lib/Tooltip/Components/TootipWrapper";

/**
 * PlainTooltip:
 *   - Typically used to display plain messages
 */
export function PlainTooltip(props) {
  const { title, className } = props;
  return (
    <TooltipWrapper className={`${style.plainTooltip} ${style[className]}`}>
      <h4>Hint</h4>
      <Content text={title} />
    </TooltipWrapper>
  );
}

PlainTooltip.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Title text
   */
  title: PropTypes.string,
};

PlainTooltip.defaultProps = {
  title: "",
  className: "",
};
